import { createFileRoute } from "@tanstack/react-router";

import EndpointGeneratorPage from "./-components/EndpointGeneratorPage";

export const Route = createFileRoute(
  "/_app/_dashboard/$planId/proxy/endpoint-generator"
)({
  component: EndpointGeneratorPage,
});
